export const weight = {
  regular: "400",
  medium: "500",
  "semi-bold": "600",
};
